import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tooltip"
export default class extends Controller {
  static targets = ["tooltip", "title", "content", "overlay"];

  connect() {
    this.isVisible = false;
  }

  showTooltip(event) {
    if (!this.hasTooltipTarget) return;

    const title = event.currentTarget.dataset.tooltipTitle;
    const content = event.currentTarget.dataset.tooltipContent;

    // Update tooltip content
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = title;
    }

    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = content;
    }

    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = "block";
    }

    this.tooltipTarget.style.display = "block";

    // Prevent body scrolling
    document.body.classList.add("popup-modal-open");

    this.isVisible = true;
  }

  hideTooltip() {
    if (!this.hasTooltipTarget) return;

    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = "none";
    }

    this.tooltipTarget.style.display = "none";

    // Re-enable body scrolling
    document.body.classList.remove("popup-modal-open");

    this.isVisible = false;
  }
}
